import {Tag} from "antd";
import React from "react";
import {useDispatch, connect} from "react-redux";
import {setTags} from "../util/redux";

function hexToRgba(hex, alpha) {
    if (!hex) return `rgba(0,0,0,${alpha})`;
    const h = hex.replace("#", "");
    if (h.length < 6) return `rgba(0,0,0,${alpha})`;
    const r = parseInt(h.substr(0, 2), 16);
    const g = parseInt(h.substr(2, 2), 16);
    const b = parseInt(h.substr(4, 2), 16);
    return `rgba(${r},${g},${b},${alpha})`;
}

const select = state => {
    const tags = state.request.tags;
    return {tags};
};

function MysTag(props) {

    const dispatch = useDispatch();

    const handleRemoveTag = (e, val, index) => {
        e.preventDefault();
        const newTags = tags.filter((rtag, i) => i !== index);
        dispatch(setTags(newTags));
    };

    const {color, index, val, tags, closable, tagName, onClose, children, style} = props;

    let closeFunc;
    if (onClose) {
        closeFunc = onClose;
    } else {
        closeFunc = (e) => {
            handleRemoveTag(e, val, index);
        };
    }

    return (
        <Tag
            key={"tag-" + index}
            color={null}
            style={{
                display: "inline-flex",
                alignItems: "center",
                marginLeft: 4,
                padding: "2px 8px",
                border: `1px solid ${color}`,
                borderLeft: `3px solid ${color}`,
                backgroundColor: hexToRgba(color, 0.08),
                color: "#262626",
                borderRadius: 4,
                fontSize: 13,
                lineHeight: "20px",
                transition: "all 0.2s",
                ...style,
            }}
            role="status"
            aria-label={`Entity: ${tagName}${children ? `, value: ${children}` : ""}`}
            onClose={closeFunc}
            closable={!closable}
        >
            {children}{children ? <span style={{margin: "0 4px", opacity: 0.3}}>|</span> : null}<strong>{tagName}</strong>
        </Tag>
    );
}

export default connect(select)(MysTag);
